<!--
  产品详情页 - 仓库库存
    id: 详情产品id
  emit:暂无
 -->
<template>
  <div class="stock-tab">
     <h1 v-if="specArray.length>1" class="theme"><i></i><span>产品规格</span></h1>
     <ul v-if="specArray.length>1" class="productCon listCPGG">
        <li v-for="(spec,index) in specArray"
         :class="{active:index === tabNum}"
         @click="tabLi(spec.id,index)">
          {{spec.specification}}
        </li>
     </ul>
     <h1 class="theme"><i></i><span>规格库存</span></h1>
     <div class="stockAll">
      <span>总库存：{{totalStock}}</span>
      <span class="right">{{rightWarming}}</span>
     </div>
     <el-table
        border
        :data="tableData"
        style="width: 95%">
        <el-table-column
          label="仓库名称"
          width="180">
          <template slot-scope="scope">
            {{scope.row.warehouseName}}
          </template>
        </el-table-column>
        <el-table-column
          :label="stockAddUnit"
          width="280">
          <template slot-scope="scope">
            {{scope.row.stock}}
          </template>
        </el-table-column>
        <el-table-column
          label="仓库成本（元）"
          v-if="haveCost"
          width="280">
          <template slot-scope="scope">
            {{scope.row.cost}}
          </template>
        </el-table-column>
        <el-table-column
          label="库存预警">
          <template slot-scope="scope">
            <span v-if="scope.row.notify !==0 && !scope.row.warming">
              [库存预警：上限 > {{scope.row.upperLimit}}；下限 <{{scope.row.lowerLimit}}]
            </span>
            <span
             v-else-if="scope.row.notify !==0 && scope.row.warming"
             :style="scope.row.warming ? 'color:#FC484F' :'color:#000' ">
              {{scope.row.warmingText}}
            </span>
            <span v-else-if="scope.row.notify ===0">
              <i style="font-style: normal;">否</i>
            </span>
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as api from 'src/api'
export default {
  created () {
    this.getTabCon()
  },
  props: {
    id: {
      type: Number
    },
    title: {
      type: String
    }
  },
  data () {
    return {
      specArray: [], // 规格数组
      tabNum: 0, // 多规格当前选中索引
      tableData: [], // 表格数据数组
      totalStock: '', // 总库存
      stockAddUnit: '', // 单位
      rightWarming: '', // 库存表右边预警
      haveCost: 0 // 是否展示成本
    }
  },
  methods: {
    // 获取接口
    getTabCon () {
      let url = `/productApi/getChildProductList.html`
      let params = {
        productId: this.id
      }
      api.post(url, params, (data) => {
        this.specArray = data.childProductList // 规格数组
        if (data.childProductList.length === 1 || data.childProductList[0]) {
          let id = data.childProductList[0].id
          this.getTableList(id)
        }
      })
    },
    // 多规格点击tab
    tabLi (id, index) {
      this.tabNum = index
      this.getTableList(id)
    },
    // 请求表格数据
    getTableList (id) {
      let url = `/productApi/getChildProductStockAjax.html`
      let params = {
        productId: id
      }
      api.post(url, params, (data) => {
        this.tableData = data.resultArray

        // 仓库库存
        this.totalStock = data.summaryObj.totalStock + data.summaryObj.unit
        if (data.summaryObj && data.summaryObj.unit !== '') {
          this.stockAddUnit = '库存（' + data.summaryObj.unit + '）'
        } else {
          this.stockAddUnit = '库存'
        }
        // 预警
        if (data.summaryObj && !data.summaryObj.isNotify) {
          this.rightWarming = ''
        } else {
          this.rightWarming = '[库存预警：上限 > ' + data.summaryObj.stockUpperLimit + '；下限 <' + data.summaryObj.stockLowerLimit + ']'
        }
        // 成本
        if (data.summaryObj && data.summaryObj.cost) {
          this.haveCost = 1
        }
      })
    }
  }
}
</script>
<style lang="less">
  .stock-tab{
    .el-table{margin: 15px auto;}
  }
</style>
<style lang="less" scoped>
  .stock-tab{
    padding:0 15px;
    .theme{background:#F1F6FE;line-height: 30px;font-size:13px;}
    .theme i{display:inline-block;width:8px;height:8px;background:#FF943E;margin:0 10px;}
    .productCon{
      margin:15px 0 0;
      margin-left: 28px;
      display: flex;
      flex-wrap: wrap;
      &.listCPGG li{padding:10px 10px;border:1px solid #ccc;cursor: pointer;
        margin-right:15px;border-radius: 2px;margin-bottom: 10px;}
      &.listCPGG li.active{border:1px solid #FF943E;background:#FF943E;color:#fff;}
    }
    .stockAll{
      margin-top: 15px;margin-left: 28px; margin-right: 28px;
      .right{float:right;}
    }
  }
</style>



// WEBPACK FOOTER //
// stock-tab.vue?1016d064